<template>
  <el-form :model="ruleForm2" :rules="rules2" ref="ruleForm2" label-position="left" label-width="0px" class="demo-ruleForm login-container">
    <h3 class="title">系统登录 - 资讯管理中心</h3>
    <el-form-item prop="account">
      <el-input type="text" v-model="ruleForm2.account" auto-complete="off" placeholder="账号"></el-input>
    </el-form-item>
    <el-form-item prop="checkPass">
      <el-input type="password" v-model="ruleForm2.checkPass" auto-complete="off" placeholder="密码"></el-input>
    </el-form-item>
    <el-form-item style="width:100%;">
      <el-button type="primary" style="width:100%;" @click.native.prevent="handleSubmit2" :loading="logining">登录</el-button>
    </el-form-item>
    <div style="line-height:24px;margin-top:10px;text-align:center;color:#666;font-size:12px;">北京亿和博嘉教育科技有限公司 &copy; 版权所有<br><a href="http://beian.miit.gov.cn" target="_blank" style="padding-right: 20px;color:#666">京ICP备12019974号</a><span style="padding-right: 15px;color:#666">经营许可证编号京B2-20180132</span><br><a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802025121" style="position: relative; padding-left: 23px;color:#666"><img src="http://source.yiboshi.com/public/img/%E5%A4%87%E6%A1%88%E5%9B%BE%E6%A0%87.png" style="width: 20px; height: 20px; position: absolute; left: 0px; top: 0px;">京公网安备&nbsp;&nbsp;11010802025121号 </a></div>
  </el-form>
</template>

<script>
  import { requestLogin } from '../api/api';
  import md5 from 'crypto-js/md5'
  export default {
    data() {
      return {
        logining: false,
        ruleForm2: {
          account: '',
          checkPass: ''
        },
        rules2: {
          account: [
            { required: true, message: '请输入账号', trigger: 'blur' },
          ],
          checkPass: [
            { required: true, message: '请输入密码', trigger: 'blur' },
          ]
        }
      };
    },
    methods: {
      handleSubmit2() {
        this.$refs.ruleForm2.validate((valid) => {
          if (valid) {
            this.logining = true;
            var loginParams = new FormData();
            loginParams.append("username",this.ruleForm2.account);
            loginParams.append("password",md5(this.ruleForm2.checkPass));
            requestLogin(loginParams).then(response => {
              this.logining = false;
              let {data} = response
              if (data.status !== 200) {
                this.$notify({
                  title: '提示',
                  message: data.msg,
                  type: 'info'
                });
              } else {
                let tokenE = data.data.tokenE
                let expireTokenDate = new Date(Date.parse(tokenE.replace(/-/g,   "/")));
                this.$storejs.set(process.env.VUE_APP_APPKEY+'token', data.data.token,expireTokenDate - (1000 * 60 * 60 * 24))
                sessionStorage.setItem(process.env.VUE_APP_APPKEY+'userInfo', JSON.stringify(data.data.userInfo));
                this.$router.push({ path: '/main' });
              }
            });
          } else {
            return false;
          }
        });
      }
    }
  }

</script>

<style lang="scss" scoped>
  .login-container {
    /*box-shadow: 0 0px 8px 0 rgba(0, 0, 0, 0.06), 0 1px 0px 0 rgba(0, 0, 0, 0.02);*/
    -webkit-border-radius: 5px;
    border-radius: 5px;
    -moz-border-radius: 5px;
    background-clip: padding-box;
    margin-bottom: 20px;
    background-color: #F9FAFC;
    margin: 180px auto;
    border: 2px solid #8492A6;
    width: 350px;
    padding: 35px 35px 15px 35px;
    .title {
      margin: 0px auto 40px auto;
      text-align: center;
      color: #505458;
    }
    .remember {
      margin: 0px 0px 35px 0px;
    }
  }
</style>
